import { NavLink } from "react-router-dom";
import {
  Home, BarChart2, PieChart, TrendingUp, Bell, FileText,
  Users, Layers, Settings, Building2, HelpCircle, Mail,
} from "lucide-react";
import { groupByMainTab } from "@/application/navigation";
import type { PortalId } from "@/domain/screen";

const TAB_ICONS: Record<string, typeof Home> = {
  Home: Home,
  "My Investment": BarChart2,
  Valuation: PieChart,
  "Company Performance": TrendingUp,
  Notifications: Bell,
  Documents: FileText,
  "Investment Overview": PieChart,
  "Investment Opportunity": TrendingUp,
  "Investors & Guests": Users,
  "Cap Table & Securities": Layers,
  Settings: Settings,
};

function iconFor(mainTab: string) {
  return TAB_ICONS[mainTab] ?? Building2;
}

export function Sidebar({ portal }: { portal: PortalId }) {
  const groups = groupByMainTab(portal);

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src="/brand/logo-sidebar.png" alt="AlifBee" width={40} height={40} style={{ objectFit: "contain" }} />
        AlifBee
      </div>
      <div className="sidebar-subtitle">{portal} Portal</div>

      {groups.map((group) => {
        const entry = group.screens[0];
        const Icon = iconFor(group.mainTab);
        return (
          <NavLink
            key={group.mainTab}
            to={entry.route}
            className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}
          >
            <Icon size={18} strokeWidth={2} />
            {group.mainTab}
          </NavLink>
        );
      })}

      <div style={{ marginTop: "auto" }}>
        <div className="sidebar-divider" />
        <a className="sidebar-link" href="#" onClick={(e) => e.preventDefault()}>
          <HelpCircle size={18} /> Need help?
        </a>
        <a className="sidebar-link" href="#" onClick={(e) => e.preventDefault()}>
          <Mail size={18} /> Contact us
        </a>
        <div className="sidebar-divider" />
        <div style={{ padding: "8px 12px", fontSize: 11, opacity: 0.55, color: "var(--sidebar-text-muted)" }}>
          © 2026 AlifBee. All rights reserved.
        </div>
      </div>
    </aside>
  );
}
